import React, { lazy, Suspense } from 'react';
import CWOConfigProvider from 'helpers/cwoConfigProvider';
import Loading from 'helpers/loading/loading';
import { CwoGptErrorBoundary } from 'components/cwo-gpt-app/CwoGptErrorBoundary';

const Component = lazy(() => import('components/cwo-gpt-app/CwoGptApp'));

const CwoGptApp = (props) => (
  <CWOConfigProvider>
    <CwoGptErrorBoundary>
      <Suspense fallback={<Loading />}>
        <Component {...props} />
      </Suspense>
    </CwoGptErrorBoundary>
  </CWOConfigProvider>
);

export default CwoGptApp;
